import { styled, Theme } from '@mui/material';
import { brightpathTheme } from '@youscience/theme';

export const sxStyles = {
  bannerBg: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: brightpathTheme.palette.secondary.main,
    padding: '0 1.25rem',
  },
  title: {
    marginBottom: '0.75rem',
  },
  button: (theme: Theme) => ({
    minWidth: '164px',
    backgroundColor: theme.palette.common.white,

    '&:hover': {
      backgroundColor: brightpathTheme.palette.secondary.contrastText,
    },
  }),
};

export const StyledBannerInner = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  justifyContent: 'space-between',
  maxWidth: '1280px',
  width: '100%',
  paddingTop: '2.25rem',
  paddingBottom: '2.5rem',
  gap: '1rem',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: '4.25rem',
    paddingBottom: '4.5rem',
  },
}));

export const StyledBannerText = styled('div')(({ theme }) => ({
  width: '100%',
  marginRight: 0,
  color: theme.palette.common.white,

  [theme.breakpoints.up('sm')]: {
    marginRight: '1.75rem',
  },
}));
